import { render } from "./Pageviewer.vue?vue&type=template&id=2492e84a"
import script from "./Pageviewer.vue?vue&type=script&lang=js"
export * from "./Pageviewer.vue?vue&type=script&lang=js"

import "./Pageviewer.vue?vue&type=style&index=0&id=2492e84a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__